// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DoNotDisturb: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M21,0.17C9.5,0.17,0.17,9.5,0.17,21S9.5,41.83,21,41.83S41.83,32.5,41.83,21
	S32.5,0.17,21,0.17z M21,37.67c-9.21,0-16.67-7.46-16.67-16.67c0-3.85,1.31-7.4,3.52-10.21l23.35,23.35
	C28.4,36.35,24.85,37.67,21,37.67z M34.15,31.21L10.79,7.85C13.6,5.65,17.15,4.33,21,4.33c9.21,0,16.67,7.46,16.67,16.67
	C37.67,24.85,36.35,28.4,34.15,31.21z"/>
</svg>;
};

export default React.memo(DoNotDisturb);
